import PropTypes from 'prop-types'
import { useState } from 'react'
import { Size } from '@opallabs/gem'
import { PopoverV2 } from '@opallabs/kuiper'
import { Button, ButtonSize, Icon } from '@opallabs/lapidary'
import LabelPicker from '../index'

import './styles.scss'

export const LabelPickerPopover = ({
  buttonSize,
  isPopover = true,
  labelSets,
  onClear,
  onSave,
  onSelect,
  onRemove,
  showSaveButton = true,
  theme = 'light',
  valid,
}) => {
  const [saveEnabled, setSaveEnabled] = useState(false)
  const handleOnSave = () => {
    setSaveEnabled(false)
    onSave()
  }
  const onClosePopover = () => {
    // Don't save twice if the user already manually saved
    if (saveEnabled) {
      handleOnSave()
    }
  }

  return (
    <PopoverV2
      className="label-picker-popover"
      onClosed={onClosePopover}
      popoverHandlers={{ appendTo: () => document.body }}
      trigger={
        <Button
          variant="ghost"
          buttonText="Manage labels"
          hideButtonText={true}
          icon={
            <Icon
              ariaMode="hidden"
              color={valid || !labelSets ? null : '#fab14d'}
              glyph="gem-label-set"
              height={Size.Icon}
              width={Size.Icon}
            />
          }
          size={buttonSize}
          theme={theme}
        />
      }
      content={
        <LabelPicker
          isPopover={isPopover}
          labelSets={labelSets}
          onClear={onClear}
          onRemove={onRemove}
          onSave={handleOnSave}
          onSelect={onSelect}
          saveEnabled={saveEnabled}
          setSaveEnabled={setSaveEnabled}
          shouldValidate={true}
          showSaveButton={showSaveButton}
          // hardcode light theme because dark theme isn't completely styled
          theme="light"
          valid={valid}
        />
      }
    />
  )
}

LabelPickerPopover.propTypes = {
  buttonSize: PropTypes.oneOf([ButtonSize.Regular, ButtonSize.Small]),
  isPopover: PropTypes.bool,
  labelSets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      isChild: PropTypes.bool,
      isRequired: PropTypes.bool,
      labels: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          title: PropTypes.string,
          labelSet: PropTypes.number,
          removeable: PropTypes.bool,
        })
      ),
      name: PropTypes.string,
      systemName: PropTypes.string,
      values: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          title: PropTypes.string,
          labelSet: PropTypes.number,
          removeable: PropTypes.bool,
        })
      ),
    })
  ),
  onClear: PropTypes.func,
  onRemove: PropTypes.func,
  onSave: PropTypes.func,
  onSelect: PropTypes.func,
  showSaveButton: PropTypes.bool,
  theme: PropTypes.oneOf(['dark', 'light']),
  valid: PropTypes.bool,
}
